import React from 'react';
import { Link } from 'react-router-dom';
import { SeoManager, getPageSeo } from '../seo';
import EmailLink from '../components/EmailLink';
import '../styles/PrivacyPage.css';

export default function TermsPage() {
  const seo = getPageSeo('terms');

  return (
    <main className="privacy-page">
      <SeoManager
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        path={seo.path}
      />
      <div className="container">
        <h1>Terms and Conditions</h1>
        <p>Last updated: 18 September 2026</p>
        <p>
          These Terms and Conditions govern your use of Type Click Tests
          (typeclicktests.com). By using the site, you agree to these terms
          and our <Link to="/privacy">Privacy Policy</Link>.
        </p>

        <h2>Use of the site</h2>
        <p>
          The tests and games are provided free for personal, non-commercial
          use. You may not copy, scrape, or republish our content, rankings,
          or game data without permission. Automated bots, spam, and attempts
          to overload the site are not allowed.
        </p>

        <h2>Scores and results</h2>
        <p>
          Scores are calculated in your browser for fun and practice. They
          are not an official certification and may differ from other typing
          or click-speed tools.
        </p>

        <h2>Acceptable conduct</h2>
        <ul>
          <li>Do not attempt to break, reverse engineer, or disrupt the site.</li>
          <li>Do not use the site to send spam or unsolicited messages.</li>
          <li>Do not impersonate Type Click Tests or misuse our contact email.</li>
        </ul>

        <h2>Intellectual property</h2>
        <p>
          The Type Click Tests name, layout, copy, and original game designs
          belong to us. Third-party marks, country names, and flag images
          remain the property of their owners.
        </p>

        <h2>Disclaimer</h2>
        <p>
          The site is provided “as is”. We do not warrant uninterrupted
          access or error-free results. We are not liable for any loss that
          comes from using or being unable to use the tests or games.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms. Continued use of the site after a change
          means you accept the updated terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms: <EmailLink />.
        </p>
      </div>
    </main>
  );
}
